export enum DateTimeFormat {
    dateFormat = 'DD/MM/YYYY',
    timeFormat = 'HH:mm',
    dateTimeFormat = `${DateTimeFormat.dateFormat} ${DateTimeFormat.timeFormat}`,
}
